<template>
  <div class="originality-video">
    <BaseInfo />
    <AdPreview />
  </div>
</template>

<script>
import BaseInfo from "./base-info/base-info";
import AdPreview from "./ad-preview/ad-preview";
export default {
  name: "originality-video",
  props: {},
  data() {
    return {};
  },
  components: { BaseInfo, AdPreview },
  methods: {},
  created() {},
};
</script>

<style scoped lang='scss'>
.originality-video {
  width: 1170px;
  display: flex;
  justify-content: space-between;
  >div {
   width: 49%;
  }
}
</style>